export const mergeCartValidation = (previous = {}, next) => {
  if (!next) return previous;
  const merge = (key) => Array.from(new Map(
    [...(previous[key] || []), ...(next[key] || [])].map((line) => [`${line.lineId}`, line]),
  ).values());
  const removedLines = merge("removedLines");
  // Quotes repeat availability checks without the validation endpoint's line
  // prices. Do not erase those prices (or MOV money) with absent quote fields.
  const retainedById = new Map((previous.retainedLines || []).map((line) => [`${line.lineId}`, line]));
  const retainedLines = (next.retainedLines || previous.retainedLines || []).map((line) => ({
    ...retainedById.get(`${line.lineId}`), ...line,
    priceQuote: line.priceQuote || retainedById.get(`${line.lineId}`)?.priceQuote || null,
  }));
  return {
    ...previous,
    ...Object.fromEntries(Object.entries(next).filter(([, value]) => value != null)),
    retainedLines,
    removedLines,
    adjustedLines: merge("adjustedLines"),
    removedLineIds: Array.from(new Set([
      ...(previous.removedLineIds || []), ...(next.removedLineIds || []),
      ...removedLines.map((line) => line.lineId),
    ])),
  };
};
